module.exports = __webpack_public_path__ + "static/media/kwell_product.603b43db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kwell_product.png
// module id = 797
// module chunks = 0